export default "__VITE_ASSET__f$BTUOmL__"